import { BaseModel } from '@/api/base-model'
import { DashboardAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'

export class Dashboard extends BaseModel<Dashboard> {
    protected collectionName = DashboardAPI.collectionName

    constructor(
        public company: Company|null,
        public id: string,
        public direction: string|null,
        public category: string|null,
        public title: string,
        public text: string,
        public sort: number,
        public component: string,
        public cumulioId: string|null,
        public cumulioExportId: string|null,
        public powerBiId: string|null,
    ) { super(id) }

    static fromData(data: any): Dashboard {
        if (data === null || typeof data === 'string' || data instanceof Dashboard) {
            return data
        }

        return new Dashboard(
            data.company ? Company.fromData(data.company) : null,
            data.id,
            data.direction,
            data.category,
            data.title,
            data.text,
            data.sort,
            data.component,
            data.cumulioId,
            data.cumulioExportId,
            data.powerBiId,
        )
    }
}
